import { observer } from "mobx-react-lite";
import { ClipboardList } from "lucide-react";
import { useTran } from "@/hooks";
import { PageHeader } from "@/components/common";
import {
  ActivityLogDetailsDialog,
  ActivityLogFilters,
  ActivityLogTable,
} from "../components";

const ActivityLogPage = observer(() => {
  const { t } = useTran();

  return (
    <div className="space-y-6">
      <PageHeader
        title={t("Activity Log")}
        description={t(
          "Review recent activity across users, modules, and dates.",
        )}
        icon={ClipboardList}
      />

      <div className="space-y-4 rounded-radius border border-border bg-card p-4">
        <ActivityLogFilters />
        <ActivityLogTable />
      </div>

      <ActivityLogDetailsDialog />
    </div>
  );
});

export default ActivityLogPage;
